import { get, post, del, postForm } from "../helpers/api_helper"

// Developer hub
export const getDeveloperHub = () => get("developer/hub")

// Application Settings — global branding (name, logo, favicon, currency, …)
export const getAppSettings = () => get("developer/application-settings")
export const saveAppSettings = formData => postForm("developer/application-settings", formData)

// Ledger features per Nature of Account
export const getLedgerFeatures = () => get("developer/ledger-features")
export const saveLedgerFeatures = groups => post("developer/ledger-features", { groups })

// Modules (enable/disable top-level modules)
export const getModules = () => get("developer/modules")
export const saveModules = modules => post("developer/modules", { modules })

// Settings Manager (fields) — runtime CRUD over setting_definitions
export const getSettingDefinitions = () => get("developer/field-manager")
export const saveSettingDefinition = (id, data) =>
  id ? post(`developer/field-manager/${id}`, data) : post("developer/field-manager", data)
export const deleteSettingDefinition = id => del(`developer/field-manager/${id}`)
